import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay for smooth appearance
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4"
        >
          <div className="max-w-7xl mx-auto">
            <div className="bg-[#0E0F14] border border-white rounded-lg p-6 shadow-2xl">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex-1">
                  <h3 className="text-white font-semibold text-lg mb-2">
                    Vi bruger cookies 🍪
                  </h3>
                  <p className="text-white/70 text-sm leading-relaxed">
                    Vi bruger cookies til at analysere trafik, forbedre din oplevelse og forstå 
                    købsadfærd på vores website. Ved at klikke "Accepter" giver du samtykke til 
                    vores brug af cookies. Læs mere i vores{" "}
                    <Link to="/privatlivspolitik" className="text-white underline hover:text-white/80">
                      privatlivspolitik
                    </Link>.
                  </p>
                </div>
                <div className="flex gap-3 shrink-0">
                  <Button
                    onClick={declineCookies}
                    className="bg-[#1A1C23] text-white border border-white hover:bg-[#1A1C23]/80 hover:scale-[1.02] hover:shadow-[0_4px_12px_rgba(255,255,255,0.15)] transition-all"
                  >
                    Afvis
                  </Button>
                  <Button
                    onClick={acceptCookies}
                    className="bg-[#1A1C23] text-white border border-white hover:bg-[#1A1C23]/80 hover:scale-[1.02] hover:shadow-[0_4px_12px_rgba(255,255,255,0.15)] transition-all"
                  >
                    Accepter cookies
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
